<template>
    <div class="pa-05rem">
        <NoData />
    </div>
</template>